import { IThongTinCbnv, IThongTinCbnvVm } from "../../../models/response/hoc-sinh/IThongTinCbnv";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objThongTinCbnvDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IThongTinCbnvVm[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IThongTinCbnv | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IThongTinCbnv,
    SAVE_SUCESS: {} as IThongTinCbnv,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eThongTinCbnvActionTypeIds = generateActionTypeIds(objThongTinCbnvDefine, "THONG_TIN_CBNV")
export type IThongTinCbnvActionTypes = IGenericActionType<typeof objThongTinCbnvDefine, "THONG_TIN_CBNV">
